module.exports = __webpack_public_path__ + "static/media/sparkle-white.69a1fa4f.png";